<template>
    <div>
        <div>{{ label }}</div>
        <div v-if="href">
            <a
                v-bind:href="href"
                target="_blank">
                {{ linkText }}
            </a>
        </div>
        <div v-else>
            {{ linkNotConfiguredHelpText }}
        </div>
    </div>
</template>

<script>
    import base from "./_elementBase";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/hyperlink.i18n";
    import { PROGRAM_TYPES } from "SharedStores/Program/programStore";
    import { PROJECT_TYPES } from "SharedStores/Project/projectStore";
    import { PROJECT_NAMESPACE } from "SharedStores/Project/projectStore";

    const projectNumberRegex = new RegExp("{PN}|{ProjectNumber}", "gi");

    export default {
        extends: base,
        computed: {
            href() {
                let href = this.element.Properties.href;
                this.element.DependencyDefinitions.forEach((dependencyDefinition) => {
                    const tag = `{${parseInt(dependencyDefinition.Label) + 1}}`;
                    const fieldVal = this.getHyperlinkDataValue(dependencyDefinition.DataFieldId);
                    if (fieldVal) {
                        href = href.replace(tag, fieldVal);
                    }
                });

                // special case replacement for {PN} or {ProjectNumber}
                if (projectNumberRegex.test(href)) {
                    href = href.replace(projectNumberRegex, this.projectNumber);
                }

                return href;
            },
            linkText() {
                const display = this.element.Properties.displaytext;
                if (!display || display == "") {
                    return this.href;
                }
                return display;
            },
            projectNumber() {
                if (this.isProjectModuleRegistered()) {
                    return this.$store.state[PROJECT_NAMESPACE].ProjectNumber ?? "";
                }
                return "";
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            getHyperlinkDataValue(dataFieldId) {
                if (this.isProjectModuleRegistered()) {
                    const listItems =
                        this.$store.getters[PROGRAM_TYPES.getters.getAllListItemsByDatafieldId](dataFieldId);
                    const fieldValue = this.getProjectValue(dataFieldId);
                    const listItem = listItems.find((item) => item.ListItemId == fieldValue);

                    if (listItem) {
                        return listItem.Value;
                    }

                    return this.$store.getters[PROJECT_TYPES.getters.dataFieldValueFromId](dataFieldId);
                }
                return null;
            }
        }
    };
</script>
